import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomers } from 'services/CustomerService'
import { CustomersRequest } from 'types/customers'
import { WithPaginationApiResponse } from 'types/pagination'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET, withPaginationPaging } from 'utils/pagination'

export const useCustomersQuery = <CustomerSummary extends object>(
  {
    search,
    size = API_PAGINATION_LIMIT,
    page = API_PAGINATION_OFFSET,
    sort = '',
    filters,
  }: CustomersRequest,
  enabled = true
) => {
  return useQuery({
    queryKey: reactQueryKeys.customers({ size, page, sort, search, filters }),
    queryFn: () => getCustomers<CustomerSummary>({ search, size, page, sort, filters }),
    select: (res: WithPaginationApiResponse<CustomerSummary[]>) => {
      const customerListWithPagination = withPaginationPaging<CustomerSummary[]>(res)
      return customerListWithPagination
    },
    enabled,
  })
}
